import { Box, Container, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import TopBar from "./components/TopBar";
import { PO_Backlog_Service } from "../../redux/po_backlog/po_backlog.services";
import TabContent from "./components/TabContent";
import { getHiddenColumnsSampleCollector } from "./utilis/sampleCollectorServices";
import LinearLoadingState from "../../common/components/LoadingState/LinearLoadingState";


const SampleCollectorHome = () => {
  const [tabValue, setTabValue] = useState(0);
  const [tabs, setTabs] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchTabs = async () => {
    setLoading(true);
    try {
      const result = await PO_Backlog_Service.sample_types_get();
      if (Array.isArray(result?.data?.data)) {
        setTabs(result?.data?.data);

      } else if (typeof result?.data?.data === "object") {
        setTabs(Object.keys(result.data?.data));

      } else {
        console.error("Unexpected data structure:", result?.data);
        setTabs([]);

      }
    } catch (error) {
      console.error(error);
      setTabs([]);

    } finally {
      // if (tabs?.length > 0) {
      // }
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTabs();
    getHiddenColumnsSampleCollector(hiddenColumns, setHiddenColumns, setLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log(hiddenColumns);
  return (
    <Box className="">
      <Box className="flex flex-col gap-3 p-2">
        <TopBar />
      </Box>
      {
        loading ? <LinearLoadingState /> : <Container maxWidth="xl">
          <Box className="flex justify-between items-baseline">
            <Tabs
              className="flex-1"
              sx={{
                borderBottom: "1px solid #e8e8e8",
                "& .MuiTabs-indicator": {
                  backgroundColor: "#084298",
                  display: "flex",
                  justifyContent: "center",
                },
                "& .MuiTabs-indicatorSpan": {
                  maxWidth: 40,
                  width: "100%",
                  // backgroundColor: '#635ee7',
                },
              }}
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons={false}
              aria-label="scrollable prevent tabs example"
            >
              {tabs?.map((tab, index) => (
                <Tab key={index} disableRipple label={(tab === "CB" ? "In Process" : tab === "FP" ? "FP Pack" : tab)} />
              ))}
            </Tabs>
            <Box></Box>
          </Box>
          {/* Render content based on the selected tab */}
          {hiddenColumns && tabs?.length > 0 && <TabContent tabName={tabs[tabValue]} hiddenColumns={hiddenColumns} />}
        </Container>
      }
    </Box>
  );
};

export default SampleCollectorHome;
